"use client"

import { BlockchainFiltersMoleculeReatom } from "@/app/blockchains/filters/blockchain-filters-molecule.reatom"
import { Slider, SliderMolecule } from "@/app/components/slider/slider"
import type { Drop } from "@anaconda/core/drop/types"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"
import { useEffect } from "react"
import { DropsSpotlightStoreMolecule } from "./drops-spotlight-store.reatom"

export interface DropForSpotlight extends Drop {
  background?: string
  preview?: string
}

interface Props {
  className?: string
  containerClassName?: string
}

export const DropsSpotlightView = reatomComponent(
  ({ className, containerClassName }: Props) => {
    return (
      <DropsSpotlightContent
        className={className}
        containerClassName={containerClassName}
      />
    )
  },
  "DropsSpotlightView",
)

const DropsSpotlightContent = reatomComponent(
  ({
    className,
    containerClassName,
  }: { className?: string; containerClassName?: string }) => {
    const { selectedBlockchain } = useMolecule(BlockchainFiltersMoleculeReatom)
    const globalBlockchain = selectedBlockchain()

    const { slidesAtom, selectedBlockchainAtom, setSelectedBlockchain } =
      useMolecule(DropsSpotlightStoreMolecule)
    const { setActiveSlideIndex } = useMolecule(SliderMolecule)

    // Sync external blockchain changes to store
    useEffect(() => {
      setSelectedBlockchain(globalBlockchain)
    }, [globalBlockchain, setSelectedBlockchain])

    // Read slides from store
    const slides = slidesAtom()

    return (
      <Slider
        slides={slides}
        key={selectedBlockchainAtom()}
        className={className}
        containerClassName={containerClassName}
        onSlideChange={setActiveSlideIndex}
      />
    )
  },
  "DropsSpotlightContent",
)
